export default __webpack_public_path__ + "6dcbc9bed1ec438907ee0751dc4cb217.ttf";